export class AccountItem {
    email: string = '';
    empNo: string = '';
    empName: string = '';
    unit: string = '';
    empId: string = '';
    azureAccountName: string = '';
    accountKey: string = '';
    reporting: boolean = false;
    sysAdmin: boolean = false;
    changeAdminAuthority: boolean = false;
    isSystemAilable: boolean = true;
}
